import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TooltipModule } from 'primeng/tooltip';
import { MarkdownComponent } from 'ngx-markdown';

import { LayoutModule } from '../Common/Layout/layout.module';
import { LocalizationModule } from '../Core/Localization/localization.module';
import { MiscModule } from '../Common/Misc/misc.module';
import { CommonFormsModule } from '../Common/Forms/forms.module';
import { CommonBasicModule } from '../Common/Basic/basic.module';
import { FilterModule } from '../Common/Filter/filter.module';
import { TakeOverModule } from '../Common/TakeOver/take-over.module';
import { BrandIdentityModule } from '../Common/BrandIdentity/brand-identity.module';
import { ChartsModule } from '../Common/Charts/charts.module';

import { ViMonitorService } from './services/vi-monitor.service';
import { ViApiService } from '../api/visibilityIntelligence/vi.api.service';
import { ViRoutingService } from './services/vi-routing.service';
import { ViActivateGuard } from './routing/vi-activate.gaurd';
import { ViMonitorSetupDeactivateGuard } from './routing/vi-monitor-setup-deactivate.guard';
import { ViLeftSidebarService } from './services/vi-left-sidebar.service';
import { ViLeftSidebarManagementService } from './services/vi-left-sidebar-management.service';
import { ViReportsSearchService } from './services/vi-reports-search.service';
import { ViSummaryChartService } from './services/vi-summary-chart.service';
import { ViChartsService } from './services/vi-charts.service';
import { ViBrandCardService } from './services/vi-brand-card.service';

import { ViReportsComponent } from './components/ViReports/vi-reports.component';
import { VisibilityIntelligenceComponent } from './components/visibility-intelligence.component';
import { ViMonitorSetupComponent } from './components/ViMonitorSetup/vi-monitor-setup.component';

import { ViBrandIdentityCardComponent } from './components/ViBrandIdentityCard/vi-brand-identity-card.component';
import { ViCompetitorsSetupPanelComponent } from './components/ViCompetitorsSetupPanel/vi-competitors-setup-panel.component';
import { ViQuerySetupDialogComponent } from './components/ViQuerySetupDialog/vi-query-setup-dialog.component';
import { ViDimensionCardComponent } from './components/ViDimensionCard/vi-dimension-card.component';
import { ViQuestionDetailsComponent } from './components/ViQuestionDetails/vi-question-details.component';
import { ViManuallyAddQuestionPanelComponent } from './components/ViManuallyAddQuestionPanel/vi-manually-add-question-panel.component';
import { ViMonitorSettingsPanelComponent } from './components/ViMonitorSettingsPanel/vi-monitor-settings-panel.component';
import { ViBrandSetupPanelComponent } from './components/ViBrandSetupPanel/vi-brand-setup-panel.component';

import {
    ViGenerateAdditionalQuestionsPanelComponent
} from './components/ViGenerateAdditionalQuestionsPanel/vi-generate-additional-questions-panel.component';
import { VISummaryComponent } from './components/ViReports/ViSummary/vi-summary.component';
import { ViResultsShellComponent } from './components/ViResultsShell/vi-results-shell.component';
import { ViQueriesAndAnswersComponent } from './components/ViQueriesAndAnswers/vi-queries-and-answers.component';
import { ViActiveQuestionSummaryComponent } from './components/ViActiveQuestionSummary/vi-active-question-summary.component';

import { ViBrandIdentityReadonlyCardComponent } from './components/ViBrandIdentityReadonlyCard/vi-brand-identity-readonly-card.component';
import { ViInsightTabComponent } from './components/ViInsightsTab/vi-insights-tab.component';
import { ViSourceOutletsTabComponent } from './components/ViSourceOutletsTab/vi-source-outlets-tab.component';
import { ViAnswerScoresComponent } from './components/ViAnswerScores/vi-answer-scores.component';
import { ViAnswerPanelComponent } from './components/ViAnswerPanel/vi-answer-panel.component';
import { ViEngineSelectorComponent } from './components/ViEngineSelector/vi-engine-selector.component';
import { ViAgentDialogComponent  } from './components/ViAgentDialog/vi-agent-dialog.component';
import { JournodexSearchesApi } from '../api/targeting/journodex-searches.api';
import { ViMonitorEditableGuard } from './routing/vi-monitor-editable.guard';
import { ViMonitorHasResultsGuard } from './routing/vi-monitor-has-results.guard';
import { ViDatePickerComponent } from './components/ViDatePicker/vi-date-picker.component';
import { ViChartDrillDownDialogComponent } from './components/ViChartDrillDownDialog/vi-chart-drill-down.dialog.component';
import { ViQuestionCardComponent } from './components/ViQuestionCard/vi-question-card.component';


@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        LocalizationModule,
        MiscModule,
        CommonFormsModule,
        CommonBasicModule,
        FormsModule,
        ReactiveFormsModule,
        TakeOverModule,
        FilterModule,
        BrandIdentityModule,
        ChartsModule,
        RouterModule,
        TooltipModule,
        MarkdownComponent,
    ],
    declarations: [
        VisibilityIntelligenceComponent,
        ViMonitorSetupComponent,
        ViReportsComponent,
        ViQueriesAndAnswersComponent,
        ViMonitorSettingsPanelComponent,
        ViBrandSetupPanelComponent,
        ViBrandIdentityCardComponent,
        ViCompetitorsSetupPanelComponent,
        ViQuerySetupDialogComponent,
        ViDimensionCardComponent,
        ViQuestionDetailsComponent,
        ViManuallyAddQuestionPanelComponent,
        ViGenerateAdditionalQuestionsPanelComponent,
        ViActiveQuestionSummaryComponent,
        VISummaryComponent,
        ViResultsShellComponent,
        ViBrandIdentityReadonlyCardComponent,
        ViInsightTabComponent,
        ViSourceOutletsTabComponent,
        ViAnswerScoresComponent,
        ViAnswerPanelComponent,
        ViEngineSelectorComponent,
        ViAgentDialogComponent,
        ViDatePickerComponent,
        ViChartDrillDownDialogComponent,
        ViQuestionCardComponent
    ],
    exports: [
        VisibilityIntelligenceComponent,
        ViInsightTabComponent,
        ViSourceOutletsTabComponent,
        ViAnswerPanelComponent,
        ViAgentDialogComponent
    ],
    providers: [
        ViMonitorService,
        ViApiService,
        ViRoutingService,
        ViActivateGuard,
        ViMonitorSetupDeactivateGuard,
        ViLeftSidebarService,
        ViLeftSidebarManagementService,
        ViReportsSearchService,
        ViSummaryChartService,
        ViChartsService,
        ViBrandCardService,
        JournodexSearchesApi,
        ViMonitorEditableGuard,
        ViMonitorHasResultsGuard,
    ]
})
export class VisibilityIntelligenceModule { }
